import React, { createContext, useState } from 'react';

export const ShopContext = createContext();

export const ShopContextProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState({});

  const addItemToCart = (product) => {
    setCartItems((prevCart) => {
      const newCart = { ...prevCart };
      if (newCart[product.id]) {
        newCart[product.id].quantity += 1;
      } else {
        newCart[product.id] = { ...product, quantity: 1 };
      }
      return newCart;
    });
  };

  const updateItemQuantity = (productId, quantity) => {
    if (quantity < 1) {
      removeItem(productId);
    } else {
      setCartItems((prevCart) => ({
        ...prevCart,
        [productId]: { ...prevCart[productId], quantity },
      }));
    }
  };

  const removeItem = (productId) => {
    setCartItems((prevCart) => {
      const newCart = { ...prevCart };
      delete newCart[productId];
      return newCart;
    });
  };

  return (
    <ShopContext.Provider value={{ cartItems, addItemToCart, updateItemQuantity, removeItem }}>
      {children}
    </ShopContext.Provider>
  );
};

